import { useEffect, useState } from "react";

function useDevice() {
  const [firstLoad, setFirstLoad] = useState(true);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [isMediumScreen, setIsMediumScreen] = useState(false);

  useEffect(() => {
    setFirstLoad(false);
  }, []);

  useEffect(() => {
    // Function to update state based on window size
    const handleResize = () => {
      const isSmallerScreen = window.innerWidth < 992;
      setIsSmallScreen(isSmallerScreen);

      const isMediumSizedScreen = window.innerWidth < 1500;
      setIsMediumScreen(isMediumSizedScreen);
    };

    // Attach the event listener
    window.addEventListener("resize", handleResize);

    // Call handleResize to set the initial state
    handleResize();

    // Clean up
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array means this effect runs once when component mounts

  const isSsr = firstLoad || typeof navigator === "undefined";
  const isAndroid = !isSsr && /android/i.test(navigator.userAgent);
  const isIphone =
    !isSsr && /iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const isIpad = !isSsr && /iPad/.test(navigator.userAgent) && !window.MSStream;
  const isMobile = isAndroid || isIphone;

  return {
    isAndroid,
    isDesktop: !isAndroid && !isIphone && isIpad,
    isIpad,
    isIphone,
    isMediumScreen,
    isMobile,
    isSmallScreen,
    isSsr,
  };
}

export default useDevice;
